@if(kpi(); as data) {
  <div class="bg-white p-5 rounded-md shadow-sm">
    <h3 class="text-sm text-gray-500 mb-1 truncate">{{ data.title | translate }}</h3>
    <p class="text-2xl font-bold text-gray-800">
      @if(data.prefix) {
        <span class="font-sans">{{ data.prefix }}</span>
      }
      {{ data.value | number:'1.2-2' }}
    </p>
    <div 
      class="text-sm mt-1 flex items-center gap-2"
      [class]="data.changeValue >= 0 ? 'text-green-600' : 'text-red-600'">
      @if (data.changeValue !== 0) {
        <i class="fa-solid" [class]="data.changeValue >= 0 ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
        <span class="font-semibold">
          {{ data.changeValue | currency:'฿':'symbol':'1.2-2' }}
          ({{ data.changePercent | percent:'1.1-2' }})
        </span>
      } @else {
        <span class="text-gray-500">- No change -</span>
      }
    </div>
  </div>
}